module.exports = __webpack_public_path__ + "images/emoji/yellow_heart.c6a2f206d128583d2492.png";